import ja from "./ja.json";
import tosJa from "./tos.json";

export default {
  ...ja,
  ...tosJa,
};
